import {
  InputBaseProps,
  TextField as Root,
  TextFieldProps,
} from '@forgeglobal/design-framework';

import { useStyles } from './style';

const TextField = ({
  label,
  startAdornment,
  endAdornment,
  ...rest
}: TextFieldProps<string>) => {
  const classes = useStyles();

  const inputProps: Partial<InputBaseProps> = {
    classes: { input: !label ? classes.input : undefined },
  };

  if (startAdornment) {
    inputProps.startAdornment = startAdornment;
  }

  if (endAdornment) {
    inputProps.endAdornment = endAdornment;
  }

  return <Root label={label} {...rest} InputProps={inputProps} />;
};

export default TextField;
